export const environment = {
    production: false,
    useMockServices: false,
    enableAuth: true,
    showLogs: true,
    apiUrl: 'https://api-dev.paacapph.org',
    cognito: {
        userPoolId: '',
        clientId: '',
        region: 'us-east-1',
        identityPoolId: ''  // Cognito Identity Pool ID for AWS SDK credentials
    },
    schemaCode: '04',
};
